export class CausedByException extends Error {
	// @ts-ignore no-implicit-override
	cause?: unknown

	constructor(options?: { message?: string; cause?: unknown }) {
		super(options?.message)
		this.cause = options?.cause
	}
}
